import { createAction } from '@ngrx/store';

export const GiftingIntelledoxRedirectContinue = createAction(
  '[Gifting Intelledox Redirect Continue] Gifting Intelledox Redirect: Continue',
);
